module.exports = __webpack_public_path__ + "static/media/poker-coin1.d4a17820.png";